import { useState } from 'react';
import type { ReportData } from '../../../hooks/useReports';
import { UpgradeModal } from '../../../components/feature/UpgradeModal';

interface Props {
  data: ReportData;
  isPremium: boolean;
  canExportCsv: boolean;
  canExportPdf: boolean;
  onExportCSV: () => void;
  onExportPDF: () => void;
  pdfGenerating?: boolean;
}

export const ExportPanel = ({ canExportCsv, canExportPdf, onExportCSV, onExportPDF, pdfGenerating }: Props) => {
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const [upgradeFeature, setUpgradeFeature] = useState('');

  const handleCsvClick = () => {
    if (canExportCsv) { onExportCSV(); return; }
    setUpgradeFeature('Exportar para CSV');
    setUpgradeOpen(true);
  };

  const handlePdfClick = () => {
    if (pdfGenerating) return;
    if (canExportPdf) { onExportPDF(); return; }
    setUpgradeFeature('Exportar para PDF');
    setUpgradeOpen(true);
  };

  return (
    <>
      <div className="flex items-center gap-3">
        <span className="text-[12px] text-gray-400 font-500">Exportar:</span>
        <button
          onClick={handleCsvClick}
          className={`flex items-center gap-2 px-4 py-2 rounded-xl text-[12px] font-600 transition-colors whitespace-nowrap border cursor-pointer
            ${canExportCsv
              ? 'border-gray-200 text-gray-600 hover:bg-gray-50'
              : 'border-amber-200 text-amber-600 bg-amber-50 hover:bg-amber-100'}`}
        >
          <i className="ri-file-text-line text-[14px]" />
          CSV
          {!canExportCsv && <i className="ri-lock-line text-[11px]" />}
        </button>
        <button
          onClick={handlePdfClick}
          disabled={pdfGenerating}
          className={`flex items-center gap-2 px-4 py-2 rounded-xl text-[12px] font-600 transition-colors whitespace-nowrap border cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed
            ${canExportPdf
              ? 'border-gray-200 text-gray-600 hover:bg-gray-50'
              : 'border-amber-200 text-amber-600 bg-amber-50 hover:bg-amber-100'}`}
        >
          {pdfGenerating ? (
            <>
              <i className="ri-loader-4-line text-[14px] animate-spin" />
              Gerando...
            </>
          ) : (
            <>
              <i className="ri-file-pdf-line text-[14px]" />
              PDF
              {!canExportPdf && <i className="ri-lock-line text-[11px]" />}
            </>
          )}
        </button>
      </div>

      <UpgradeModal
        open={upgradeOpen}
        onClose={() => setUpgradeOpen(false)}
        title={`Desbloquear: ${upgradeFeature}`}
        description="Exporte seus dados financeiros em formatos profissionais com um plano pago."
      />
    </>
  );
};
